module.exports = __webpack_public_path__ + "assets/img/1506_05.jpg?ad54883b546a096ea2caf6e708c621c1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1506_05.jpg
// module id = 1090
// module chunks = 0